export default "parent-companies";
